module.exports = __webpack_public_path__ + "images/pages/for_business/pc/img02_b9667ae71e6cc97df1b7a5c84707f019.png";